<template>
    <el-dialog
        class="line-search-dialog"
        v-drag
        title="线路查询"
        :visible.sync="visible"
        width="700px"
        :close-on-click-modal="false"
        :before-close="close">
        <div>
            <el-form inline ref="form" :model="form" label-width="120px">
                <el-form-item label="始发地">
                    <AddrCascader
                        v-model="form.start"
                        :minLayers="3"
                        :placeholder="'始发地'"
                        :collapseTags="true"
                        :basicProps="{ checkStrictly: true }"></AddrCascader>
                </el-form-item>
                <el-form-item label="目的地">
                    <AddrCascader
                        v-model="form.end"
                        :minLayers="3"
                        :placeholder="'目的地'"
                        :collapseTags="true"
                        :basicProps="{ checkStrictly: true }"></AddrCascader>
                </el-form-item>
                <el-form-item label="是否零担自营线路">
                    <m-select
                        :value="form.isSelfManage"
                        @input="data => getSelectValue(data, 'isSelfManage')"
                        :optionNum="'SRM_YES_OR_NO'" />
                </el-form-item>
                <el-form-item label="审批状态">
                    <m-select
                        :multiple="true"
                        :value="form.approvalStatusList"
                        @input="data => getSelectValue(data, 'approvalStatusList')"
                        :optionNum="'SRM_COMMON_ROUTE_AUDIT_STATUS'" />
                </el-form-item>
                <el-form-item label="始发地货站">
                    <el-input class="search-input" v-model="form.originStationName"></el-input>
                </el-form-item>
                <el-form-item label="目的地货站">
                    <el-input class="search-input" v-model="form.destinationStationName"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import AddrCascader from '../../../../../resource/transportPortrait/components/AddrCascader/index.vue'
import MSelect from '@/components/lots/otpSelect2'
import { cloneDeep } from 'lodash'
export default {
    components: { AddrCascader, MSelect },
    props: {
        searchObj: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            visible: false,
            form: {},
        }
    },
    methods: {
        getSelectValue(v, prop) {
            this.form[prop] = v
        },
        close() {
            this.visible = false
        },
        open() {
            this.visible = true
            this.form = cloneDeep(this.searchObj)
        },
        confirm() {
            this.$emit('confirm', this.form)
            this.close()
        },
    },
}
</script>
<style lang="less" scoped>
.line-search-dialog {
    .search-input {
        width: 178px;
    }
}
</style>
